import {camelCase, deburr, join, startCase, toLower, words} from "lodash"

/**
 * Retourne un id au format camelCase composé d'un prefix et des 5 premiers mots d'un texte.
 * Exemple : getDataTestId("Etape suivante", "Bouton") -> "boutonEtapeSuivante"
 * @param {String} text un texte dont on va garder les 5 premiers mots (ou moins)
 * @param {String} prefix le prefix (optionnel)
 * @returns le data-testid au format camelCase
 */
export const getDataTestId = (text, prefix) => {
    // Si le texte est long, on garde les 5 premiers mots (et on retire les accents et les caractères spéciaux)
    let mots = words(deburr(text), /[a-zA-Z0-9]+/g).slice(0, 5)

    // On ajoute le prefix en première position s'il est défini
    if (prefix) {
        mots = [prefix, ...mots]
    }

    // On retourne l'id au format camelCase
    return camelCase(join(mots, " "))
}

/**
 * Permet de normaliser l'affichage d'un nom : PIERRE DURAND -> Pierre Durand
 * @param {String} name
 * @returns le nom avec la première lettre de chaque mot en majuscule
 */
export const normalizeNameCase = name => startCase(toLower(name))

/**
 * Normalise l'affichage d'un numéro de téléphone français.
 * Exemple : "0235151617" -> "02 35 15 16 17"
 * @param {String} value numéro de téléphone (chiffres uniquement ou avec espaces)
 * @returns le numéro formaté en groupes de 2 chiffres séparés par des espaces
 */
export const normalizeTelephoneNumber = value => {
    if (!value) return ""
    const digits = String(value).replace(/\D/g, "")
    return digits.match(/.{1,2}/g)?.join(" ") ?? ""
}
